
import React from 'react';
import "./styles/Roadmap.scss";

/* import { useState } from "react";
import { StackItem } from '@chakra-ui/react'; */






export default function Roadmap() {

    
    
 
    return (
        <section className="roadmap">
            <h1>Roadmap</h1>
            
            <p>No official roadmap, no utility!
            Just collect, have fun, enjoy the art.</p>
            <p>There are some plans however...<br />
                <br />
                <ul>
                 <li>Create one of the strongest Canto NFT Communities</li>
                 <li>Holder verifying and Sales Bot on Discord</li>
                 <li>Support and collab with other upcoming Canto Projects</li>
                 <li>Contribute to the growth and adaption of the Canto Ecosystem</li>
                 <li>Hold a Cuteness Contest to rank all Canto Cuties. Extend the metadata to include the resulting rank</li>
                 <li>Benefits for Holders in upcoming Collections</li>
            </ul>
            </p>
            
        </section>
    ); 
}
